var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: {}, attrs: { gutter: _vm.config.gutter } },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.config.span } },
        [
          _c(
            "el-card",
            {
              class: _vm.config.borderClass,
              attrs: { shadow: _vm.config.shadow }
            },
            [
              _c("div", { staticClass: "panel-title" }, [
                _vm._v(_vm._s(_vm.$t(_vm.config.name)))
              ]),
              _vm._v(" "),
              _vm.config.type === "file"
                ? void 0
                : _vm.config.type !== "image"
                ? [
                    _c("el-alert", {
                      attrs: {
                        closable: false,
                        title: _vm.$t("excel.tip"),
                        type: "success"
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "15px" },
                  attrs: { size: "mini" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.config.type != "image"
                            ? _vm.$t("upload.fileUpload")
                            : ""
                      }
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "upload-demo",
                          attrs: {
                            action: _vm.config.action,
                            "list-type": _vm.config.listType,
                            multiple: _vm.config.multiple,
                            "file-list": _vm.config.fileList,
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.onSuccess,
                            "on-remove": _vm.onRemove,
                            "on-error": _vm.onError,
                            accept: _vm.config.accept,
                            "auto-upload": _vm.config.autoUpload,
                            headers: { Authorization: _vm.token }
                          }
                        },
                        [
                          _vm.config.type == "image"
                            ? [
                                _c("i", {
                                  staticClass: "el-icon-plus",
                                  attrs: { slot: "default" },
                                  slot: "default"
                                }),
                                _vm._v(" "),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "el-upload__tip",
                                    attrs: { slot: "tip" },
                                    slot: "tip"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("image.tip")) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            : _vm.config.type == "file"
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "trigger",
                                      size: "small",
                                      disabled: _vm.config.disabled,
                                      type: "primary"
                                    },
                                    slot: "trigger"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("upload.chioseFile")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "margin-top": "-10px"
                                    },
                                    attrs: {
                                      size: "small",
                                      type: "success",
                                      disabled: _vm.config.disabled
                                    },
                                    on: { click: _vm.submitUpload }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("upload.send")))]
                                )
                              ]
                            : [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "trigger",
                                      size: "small",
                                      disabled: _vm.config.disabled,
                                      type: "primary"
                                    },
                                    slot: "trigger"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("upload.chioseFile")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "margin-top": "-10px"
                                    },
                                    attrs: {
                                      size: "small",
                                      type: "success",
                                      disabled: _vm.config.disabled
                                    },
                                    on: { click: _vm.submitUpload }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("upload.send")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "el-upload__tip",
                                    attrs: { slot: "tip" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleClick(
                                          _vm.config.templateEvent
                                        )
                                      }
                                    },
                                    slot: "tip"
                                  },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        staticStyle: {
                                          color: "#06c",
                                          "font-size": "13px"
                                        },
                                        attrs: { href: "#", type: "success" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("upload.downTemplate"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: { visible: _vm.dialogVisible },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
                  })
                ]
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66afef91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66afef91","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload.vue
// module id = null
// module chunks = 